import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = s((e, r) => /* @__PURE__ */ o.jsx(
  t,
  {
    ref: r,
    ...e,
    image: (a) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...a,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M10 14a6 6 0 1 0 0-12 6 6 0 0 0 0 12m12 16a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-10-9a5 5 0 1 1-10 0 5 5 0 0 1 10 0m9-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
i.displayName = "DarkSpotsIcon";
export {
  i as DarkSpotsIcon,
  i as default
};
//# sourceMappingURL=index.js.map
